module.exports = __webpack_public_path__ + "static/media/Autohaus_Logo.ee775a67.jpg";